// extracted by mini-css-extract-plugin
export default {"wrapperBonusInfo":"PromoCodeTitle_wrapperBonusInfo__HF7rC","title":"PromoCodeTitle_title__zkLWP","description":"PromoCodeTitle_description__lZdbZ"};